import React, { useState, useEffect } from 'react';
import api from '../api/axiosConfig';
import './GradeManager.css';

const GradeManager = ({ onGradeSelected }) => {
  const [grades, setGrades] = useState([]);
  const [newGrade, setNewGrade] = useState({ level: '', name: '' });
  useEffect(() => {
    fetchGrades();
  }, []);

  const fetchGrades = async () => {
    try {
      const { data } = await api.get('/admin/grades'); // Make sure you have a GET route in your backend!
      setGrades(data);
    } catch (err) { console.error("Error fetching grades"); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/admin/grades', newGrade);
      setNewGrade({ level: '', name: '' });
      fetchGrades();
    } catch (err) { alert("Failed to add grade"); }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure? This will delete all subjects and topics inside this grade!")) {
      try {
        await api.delete(`/admin/grades/${id}`);
        // Refresh the list locally after successful delete
        setGrades(grades.filter(grade => grade.id !== id));
      } catch (err) {
        alert("Error deleting grade: " + err.response?.data?.message);
      }
    }
  };

  return (
    <div>
      <h2 style={{ marginBottom: '1.5rem' }}>Manage Grades</h2>

      {/* Form to Add Grade */}
      <form onSubmit={handleSubmit} style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', marginBottom: '2rem', display: 'flex', gap: '10px' }}>
        <input type="number" placeholder="Level (e.g. 1)" value={newGrade.level} onChange={e => setNewGrade({ ...newGrade, level: e.target.value })} required style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }} />
        <input type="text" placeholder="Name (e.g. First Grade)" value={newGrade.name} onChange={e => setNewGrade({ ...newGrade, name: e.target.value })} required style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }} />
        <button type="submit" style={{ padding: '8px 16px', backgroundColor: '#2563eb', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Add Grade</button>
      </form>

      {/* List of Grades */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '1rem' }}>
        {grades.map(grade => (
          <div key={grade.id} className="grade-card" onClick={()=> onGradeSelected(grade.id)}>
            <h3>{grade.name}</h3>
            <p>Level: {grade.level}</p>
            <button
              onClick={() => handleDelete(grade.id)}
              style={{ color: '#ef4444', border: 'none', background: 'none', cursor: 'pointer', marginTop: '10px', fontWeight: 'bold' }}
            >
              Delete Grade
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GradeManager;